import { render, staticRenderFns } from "./PassportFlyout.vue?vue&type=template&id=203b0bd8&scoped=true&"
import script from "./PassportFlyout.vue?vue&type=script&lang=js&"
export * from "./PassportFlyout.vue?vue&type=script&lang=js&"
import style0 from "./PassportFlyout.vue?vue&type=style&index=0&id=203b0bd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203b0bd8",
  null
  
)

export default component.exports